<h2 mat-dialog-title [ngClass]="{ pink: data?.isPinkTitle }">
  {{ data?.title }}
</h2>
<mat-dialog-content [innerHTML]="data?.message"></mat-dialog-content>
<mat-dialog-actions align="end">
  @if (showLoginBtn) {
    <button
      [disabled]="disableBtn"
      mat-button
      class="btn btn-pink"
      id="dialog-confirm-login-button"
      (click)="logout()"
      >
      Login
    </button>
  }
  @if (!data?.isPinkTitle && !data?.hideCancelBtn && !showLoginBtn) {
    <button
      mat-button
      class="btn btn-pink"
      mat-dialog-close
      id="dialog-confirm-close-button"
      >
      {{ data.cancelBtnText || 'Close' }}
    </button>
  }
  @if (data?.confirmationModal) {
    <button
      mat-button
      class="btn btn-pink"
      [mat-dialog-close]="true"
      id="dialog-confirm-confirm-button"
      >
      {{ data.confirmBtnText || 'Confirm' }}
    </button>
  }
  @if (data?.isPinkTitle) {
    <button
      mat-button
      class="btn btn-pink"
      [mat-dialog-close]="true"
      id="dialog-confirm-ok-button"
      >
      Okay
    </button>
  }
  @if (data?.showTaxButton) {
    <button
      mat-button
      class="btn btn-pink"
      id="dialog-confirm-tax-button"
      (click)="navigateToTaxInfo()"
      >
      Submit Tax Info
    </button>
  }
</mat-dialog-actions>
